import { render, staticRenderFns } from "./Reboques.vue?vue&type=template&id=2f3e85b8&"
import script from "./Reboques.vue?vue&type=script&lang=js&"
export * from "./Reboques.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports